// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export interface EnterpriseLearnerProfileImportOperationsV1 {
  id: string;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface EnterpriseLearnerProfileImportOperationsV1Connection {
  elements: Array<EnterpriseLearnerProfileImportOperationsV1> | null;
}

// ========================================================================
// Definitions for naptime-link mutations
// ========================================================================

export interface EnterpriseLearnerProfileImportOperationsV1GenerateBulkUploadLocationMutation {
  EnterpriseLearnerProfileImportOperationsV1: {
    generateBulkUploadLocation: EnterpriseLearnerProfileImportOperationsV1Connection | null;
  } | null;
}

export interface EnterpriseLearnerProfileImportOperationsV1GenerateBulkUploadLocationMutationVariables {
  thirdPartyOrganizationId: string;
  includes?: string | null;
}

export interface EnterpriseLearnerProfileImportOperationsV1PreviewCSVImportMutation {
  EnterpriseLearnerProfileImportOperationsV1: {
    previewCSVImport: EnterpriseLearnerProfileImportOperationsV1Connection | null;
  } | null;
}

export interface EnterpriseLearnerProfileImportOperationsV1PreviewCSVImportMutationVariables {
  includes?: string | null;
}

export interface EnterpriseLearnerProfileImportOperationsV1ProcessCSVImportMutation {
  EnterpriseLearnerProfileImportOperationsV1: {
    processCSVImport: EnterpriseLearnerProfileImportOperationsV1Connection | null;
  } | null;
}

export interface EnterpriseLearnerProfileImportOperationsV1ProcessCSVImportMutationVariables {
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class EnterpriseLearnerProfileImportOperationsV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'enterpriseLearnerProfileImportOperations.v1' as const;

  declare id: string;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<EnterpriseLearnerProfileImportOperationsV1>) {
    super(params);
  }
}
